// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"487":"c7514ed2","506":"7d039676","585":"636d47eb","594":"967736bf"}[chunkId] + ".js";
};